import { ConeSide } from './ConeSide';
export class ConeRightSide extends ConeSide {
    constructor(cone) {
        super();
        this.Cone = cone;
    }
    get Start() {
        return this.Cone.Apex;
    }
    get Direction() {
        return this.Cone.RightSideDirection;
    }
    toString() {
        return 'ConeRightSide ' + this.Start + ' ' + this.Direction;
    }
}
//# sourceMappingURL=ConeRightSide.js.map